export const inactiveInitialState = {
  error: {},
  data: {},
  selectedDomain: {},
  loadingSelectedDomain: false,
  loading: false,
};
